import { modules } from 'veritone-redux-common';
const {
  config: { getConfig }
} = modules;

const getEngineSearch = state => {
  const config = getConfig(state);
  return config.engineSearch;
};

export default getEngineSearch
